import { Component } from "../component"
import SlimSelect from "slim-select"
import { deviceWidth } from "../helpers/device-size"

export class CountrySelect extends Component {
  constructor(props) {
    super(props)
  }

  ui() {
    return {
      select: ".select-custom",
      selectForm: ".country-selector-form",
      selectorItems: ".country-selector-item",
    }
  }

  initSlimSelect() {
    const { select, selectForm, selectorItems } = this.$ui
    const countryOptions = Array.from(selectorItems)

    const data = countryOptions.map((option) => ({
      text: option.dataset.name,
      value: option.value,
      selected: option.selected,
      html: `${option.dataset.flag} ${option.dataset.name}`,
    }))

    this.slimSelect = new SlimSelect({
      select: select,
      data: data,
      settings: {
        hideSelected: true,
        openPosition: select.dataset.openposition,
      },
      events: {
        afterChange: () => {
          selectForm.submit()
        },
      },
    })
  }

  attachEvents() {
    const {
      select,
      selectForm,
    } = this.$ui
    const deviceType = deviceWidth()
    const isDesktop = deviceType !== "PHONE" && deviceType !== "TABLET"

    const slimSelectLists = document.querySelectorAll(".ss-content .ss-list")

    const showSelect = () => {
      slimSelectLists.forEach((slimSelectList) => {
        slimSelectList.style.maxHeight = "122px"
      })
      selectForm.style.opacity = 1
      selectForm.style.pointerEvents = "auto"
    }

    locationButton.addEventListener(
      "click",
      isDesktop && showSelect
    )
  }

  created() {
    this.initSlimSelect()
  }
}
